export const PARENT_SIGNUP_RALLY_TEXT =
  'Your child wants to join an esports team at their school. Before your child’s coach can add them to a team and start competing, we require a quick parent account creation and identity verification. Let’s get started!'

export const PARENT_SIGNUP_STADIUM_TEXT =
  'Your child wants to join esports competition on PlayVS Stadium. Before your child can start competing, we require a quick parent account creation and identity verification. Let’s get started!'
